import { Button, DatePicker, Form, Input, Select, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getAllFranchises } from "../../redux/rtk/features/franchise/franchiseSlice";
import { addBooking, getAllBookings } from "../../redux/rtk/features/crm/booking/bookingSlice";
import { getAvailableSlots } from "../../redux/rtk/features/slot/slotSlice";

dayjs.extend(customParseFormat);

export default function CreateBookingForm({ onClose, createAs }) {
	// selector

	const { list: franchiseList, isFetchingFranchises } = useSelector(
		(state) => state.franchise
	);
	const { availableSlots, isFetchingAvailableSlots } = useSelector(
		(state) => state.slot
	);
	const { isSubmitting } = useSelector(
		(state) => state.booking
	)

	const [loader, setLoader] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [productList, setProductList] = useState([]);
	const [productId, setProductId] = useState("");
	const [userId, setUserId] = useState(0);
	const [maxPlayer, setMaxPlayer] = useState(0);
	const [date, setDate] = useState("");

	useEffect(() => {
		dispatch(getAllFranchises({ status: true }));
	}, [dispatch]);

	const onFinish = async (values) => {
		try {
			setLoader(true);
			const { bookingDate, ...rest } = values;
			const formData = {
				...rest,
				bookingDate: date,
				originalAmount: Number(values.finalAmount),
				finalAmount: Number(values.finalAmount),
				numberOfParticipants: Number(values.numberOfParticipants),
				slotTime: availableSlots?.slots?.find((item) => item.id === values.slotId)?.slotName,
				couponDiscount: 0,
				transactionCode: "N/A",
			};

			await dispatch(addBooking(formData)).unwrap();
			form.resetFields();
			dispatch(getAllBookings({ status: true }));
			onClose();
		} catch (error) {
			console.error(error);
		}
	};

	const onCancel = () => {
		form.resetFields();
		onClose();
	};

	const { Option } = Select;

	const handleSelectedGames = (companyId) => {
		setUserId(companyId);
		franchiseList.map((item) => {
			if (item.id === companyId) {
				setMaxPlayer(item.maxPlayers)
				setProductList(item.product);
			}
		})
	}
	const getAvailableSlotsList = async () => {
		try {
			const res = await dispatch(getAvailableSlots({ date, productId, userId })).unwrap();
		} catch (error) {
			console.error(error);
		}
	}
	useEffect(() => {
		if (date && productId && userId) {
			getAvailableSlotsList();
		}
	}, [date, productId, userId])


	const numberOfPlayers = Array.from({ length: Number(maxPlayer) - 1 || 0 }, (_, i) => i + 2);


	return (
		<div className='flex justify-center px-6 py-4'>
			<Form
				className='w-full'
				onFinish={onFinish}
				colon={false}
				layout='vertical'
				form={form}
				initialValues={
					createAs
						? {
							[createAs.name]: createAs.value,
						}
						: {}
				}>
				<div className='flex justify-center gap-5'>
					<div className='w-1/2'>
						<Form.Item label='Franchise' name='franchiseId'
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please select franchise." },
							]}>
							<Select
								style={{ width: "100%" }}
								loading={isFetchingFranchises}
								allowClear
								showSearch
								placeholder='Select Franchise Name'
								disabled={!!(createAs?.name === "companyId")}
								onChange={(e) => handleSelectedGames(e)}
							>
								{franchiseList?.map((item) => (
									<Select.Option key={item.id} value={item.id}>
										{item.franchiseName}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
					<div className='w-1/2'>
						<Form.Item
							label='Game Room'
							name={"gameId"}
							tooltip='This is a required field'
							rules={[
								{ required: true, message: "Please select game." },
							]}>
							<Select
								style={{ width: "100%" }}
								loading={isFetchingFranchises}
								allowClear
								showSearch
								placeholder='Select Game'
								onChange={(e) => setProductId(e)}
							>
								{productList?.map((item) => (
									<Select.Option key={item.product.id} value={item.product.id}>
										{item.product.gameName}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="border-t border-[#ccc]">
					<h2 className="font-bold text-2xl mt-3 mb-2">Fill Booking Details</h2>
					<Row gutter={16}>
						<Col xs={24} md={12}>
							<Form.Item label="Choose Booking Date" name="bookingDate" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select date." },
								]}>
								<DatePicker
									format="DD-MM-YYYY"
									style={{ width: "100%" }}
									onChange={(date, dateString) => setDate(date ? date.format('MM-DD-YYYY') : '')}
									disabledDate={(current) => {
										return current && current <= dayjs().endOf('day');
									}}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Participant Name" name="name" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please enter participant name." },
									{ whitespace: true, message: "Name cannot be empty" },
									{ min: 2, message: "Name must be at least 2 characters" },
									{ max: 50, message: "Name cannot exceed 50 characters" }
								]}>
								<Input placeholder="Enter Name" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Select Participants" name="numberOfParticipants" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select participants." },
								]}>
								<Select placeholder="Select Participants">
									{numberOfPlayers.map((option) => (
										<Option key={option} value={option.toString()}>
											{option}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Participant Email" name="email" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please enter participant Email." },
									{ whitespace: true, message: "Email cannot be empty" },
									{ type: 'email', message: "Please enter a valid email address" }
								]}>
								<Input placeholder="Enter Email" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Select Slot" name="slotId" required tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select slot." },
								]}>
								<Select placeholder="Please Select Slot" loading={isFetchingAvailableSlots}>
									{availableSlots?.slots?.map((item) => (
										<Select.Option key={item.id} value={item.id}>
											{item.slotName}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Participant Contact" name="contact" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please enter contact number." },
									{ whitespace: true, message: "Contact number cannot be empty" },
									{
										pattern: /^\+?[0-9]{10,15}$/,
										message: "Please enter a valid phone number (10-15 digits)",
									}
								]}>
								<Input placeholder="Enter Contact here" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Amount" name="finalAmount" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please enter amount." },
									{ whitespace: true, message: "Amount cannot be empty" },
									{ pattern: /^[0-9]+$/, message: "Amount must be a number" },
									{
										validator: (_, value) => {
											if (value && value <= 0) {
												return Promise.reject("Amount must be greater than 0");
											}
											return Promise.resolve();
										}
									}
								]}>
								<Input placeholder="Enter Slot cost" />
							</Form.Item>
						</Col>
						<Col xs={24} md={12}>
							<Form.Item label="Choose Payment Type" name="paymentGateway" required
								tooltip='This is a required field'
								rules={[
									{ required: true, message: "Please select payment type." },
								]}>
								<Select placeholder="Please Select Payment Type">
									<Option value="Cash">Cash</Option>
								</Select>
							</Form.Item>
						</Col>
					</Row>
				</div>
				<div className='flex justify-center'>
					<div className='w-full'>
						<Form.Item label=''>
							<div className='flex items-center justify-end gap-2'>
								<Button
									size={"large"}
									htmlType='submit'
									type='danger'
									onClick={onCancel}
									className="btn-tertiary"
								>
									Cancel
								</Button>
								<Button
									size={"large"}
									htmlType='submit'
									loading={isSubmitting}
									className="btn-primary hover:border-[#E5383B]"
								>
									Create
								</Button>
							</div>
						</Form.Item>
					</div>
				</div>
			</Form>
		</div>
	);
}
